export const INITIALIZE_ABOUT_PAGE = 'initialize-about-page';
const initializeAboutPage = () => ({ type: INITIALIZE_ABOUT_PAGE });
export default initializeAboutPage;
